import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/search';

const namespace = 'BI';

export const FETCH_TOTALS_IN_PROGRESS_START = `${namespace}/FETCH_TOTALS_IN_PROGRESS_START`;
export const FETCH_TOTALS_IN_PROGRESS_SUCCESS = `${namespace}/FETCH_TOTALS_IN_PROGRESS_SUCCESS`;
export const FETCH_TOTALS_IN_PROGRESS_ERROR = `${namespace}/FETCH_TOTALS_IN_PROGRESS_ERROR`;

export const FETCH_SEARCH_CONFIG_START = `${namespace}/FETCH_SEARCH_CONFIG_START`;
export const FETCH_SEARCH_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_CONFIG_SUCCESS`;
export const FETCH_SEARCH_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_CONFIG_ERROR`;

export const FETCH_SEARCH_RESULTS_CONFIG_START = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_START`;
export const FETCH_SEARCH_RESULTS_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_SUCCESS`;
export const FETCH_SEARCH_RESULTS_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_ERROR`;

export const FETCH_REPORT_START = `${namespace}/FETCH_REPORT_START`;
export const FETCH_REPORT_SUCCESS = `${namespace}/FETCH_REPORT_SUCCESS`;
export const FETCH_REPORT_ERROR = `${namespace}/FETCH_REPORT_ERROR`;

export const FETCH_REPORT_STANDALONE_START = `${namespace}/FETCH_REPORT_STANDALONE_START`;
export const FETCH_REPORT_STANDALONE_SUCCESS = `${namespace}/FETCH_REPORT_STANDALONE_SUCCESS`;
export const FETCH_REPORT_STANDALONE_ERROR = `${namespace}/FETCH_REPORT_STANDALONE_ERROR`;

export const FETCH_MASS_CREATE_START = `${namespace}/FETCH_MASS_CREATE_START`;
export const FETCH_MASS_CREATE_SUCCESS = `${namespace}/FETCH_MASS_CREATE_SUCCESS`;
export const FETCH_MASS_CREATE_ERROR = `${namespace}/FETCH_MASS_CREATE_ERROR`;

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const SEARCH_STANDALONE_START = `${namespace}/SEARCH_STANDALONE_START`;
export const SEARCH_STANDALONE_SUCCESS = `${namespace}/SEARCH_STANDALONE_SUCCESS`;
export const SEARCH_STANDALONE_ERROR = `${namespace}/SEARCH_STANDALONE_ERROR`;

export const CREATE_REPORT_DEFINITION_START = `${namespace}/CREATE_REPORT_DEFINITION_START`;
export const CREATE_REPORT_DEFINITION_SUCCESS = `${namespace}/CREATE_REPORT_DEFINITION_SUCCESS`;
export const CREATE_REPORT_DEFINITION_ERROR = `${namespace}/CREATE_REPORT_DEFINITION_ERROR`;

export const GENERATE_REPORT_START = `${namespace}/GENERATE_REPORT_START`;
export const GENERATE_REPORT_SUCCESS = `${namespace}/GENERATE_REPORT_SUCCESS`;
export const GENERATE_REPORT_ERROR = `${namespace}/GENERATE_REPORT_ERROR`;

export const DOWNLOAD_REPORT_LONG_START = `${namespace}/DOWNLOAD_REPORT_LONG_START`;
export const DOWNLOAD_REPORT_LONG_SUCCESS = `${namespace}/DOWNLOAD_REPORT_LONG_SUCCESS`;
export const DOWNLOAD_REPORT_LONG_ERROR = `${namespace}/DOWNLOAD_REPORT_LONG_ERROR`;

export const POLL_REPORT_START = `${namespace}/POLL_REPORT_START`;
export const POLL_REPORT_SUCCESS = `${namespace}/POLL_REPORT_SUCCESS`;
export const POLL_REPORT_ERROR = `${namespace}/POLL_REPORT_ERROR`;

export const CREATE_REPORT_EVENTS_START = `${namespace}/CREATE_REPORT_EVENTS_START`;
export const CREATE_REPORT_EVENTS_SUCCESS = `${namespace}/CREATE_REPORT_EVENTS_SUCCESS`;
export const CREATE_REPORT_EVENTS_ERROR = `${namespace}/CREATE_REPORT_EVENTS_ERROR`;

export const UPDATE_REPORT_DEFINITION_START = `${namespace}/UPDATE_REPORT_DEFINITION_START`;
export const UPDATE_REPORT_DEFINITION_SUCCESS = `${namespace}/UPDATE_REPORT_DEFINITION_SUCCESS`;
export const UPDATE_REPORT_DEFINITION_ERROR = `${namespace}/UPDATE_REPORT_DEFINITION_ERROR`;

export const FINALIZE_REPORT_SUBMISSION_START = `${namespace}/FINALIZE_REPORT_SUBMISSION_START`;
export const FINALIZE_REPORT_SUBMISSION_SUCCESS = `${namespace}/FINALIZE_REPORT_SUBMISSION_SUCCESS`;
export const FINALIZE_REPORT_SUBMISSION_ERROR = `${namespace}/FINALIZE_REPORT_SUBMISSION_ERROR`;

export const CREATE_REPORT_SUBMISSION_START = `${namespace}/CREATE_REPORT_SUBMISSION_START`;
export const CREATE_REPORT_SUBMISSION_SUCCESS = `${namespace}/CREATE_REPORT_SUBMISSION_SUCCESS`;
export const CREATE_REPORT_SUBMISSION_ERROR = `${namespace}/CREATE_REPORT_SUBMISSION_ERROR`;

export const PROCESS_REPORT_JOB_START = `${namespace}/PROCESS_REPORT_JOB_START`;
export const PROCESS_REPORT_JOB_SUCCESS = `${namespace}/PROCESS_REPORT_JOB_SUCCESS`;
export const PROCESS_REPORT_JOB_ERROR = `${namespace}/PROCESS_REPORT_JOB_ERROR`;

export const GET_REPORT_JOBS_START = `${namespace}/GET_REPORT_JOBS_START`;
export const GET_REPORT_JOBS_SUCCESS = `${namespace}/GET_REPORT_JOBS_SUCCESS`;
export const GET_REPORT_JOBS_ERROR = `${namespace}/GET_REPORT_JOBS_ERROR`;

export const FETCH_REPORT_SUBMISSIONS_START = `${namespace}/FETCH_REPORT_SUBMISSIONS_START`;
export const FETCH_REPORT_SUBMISSIONS_SUCCESS = `${namespace}/FETCH_REPORT_SUBMISSIONS_SUCCESS`;
export const FETCH_REPORT_SUBMISSIONS_ERROR = `${namespace}/FETCH_REPORT_SUBMISSIONS_ERROR`;

export const FETCH_ROLL_CORRECTIONS_START = `${namespace}/FETCH_ROLL_CORRECTIONS_START`;
export const FETCH_ROLL_CORRECTIONS_SUCCESS = `${namespace}/FETCH_ROLL_CORRECTIONS_SUCCESS`;
export const FETCH_ROLL_CORRECTIONS_ERROR = `${namespace}/FETCH_ROLL_CORRECTIONS_ERROR`;

export const GET_REPORT_INFO_START = `${namespace}/GET_REPORT_INFO_START`;
export const GET_REPORT_INFO_SUCCESS = `${namespace}/GET_REPORT_INFO_SUCCESS`;
export const GET_REPORT_INFO_ERROR = `${namespace}/GET_REPORT_INFO_ERROR`;

export const POST_COMMENT_START = `${namespace}/POST_COMMENT_START`;
export const POST_COMMENT_SUCCESS = `${namespace}/POST_COMMENT_SUCCESS`;
export const POST_COMMENT_ERROR = `${namespace}/POST_COMMENT_ERROR`;

export const GET_COMMENTS_START = `${namespace}/GET_COMMENTS_START`;
export const GET_COMMENTS_SUCCESS = `${namespace}/GET_COMMENTS_SUCCESS`;
export const GET_COMMENTS_ERROR = `${namespace}/GET_COMMENTS_ERROR`;

export const DELETE_COMMENT_START = `${namespace}/DELETE_COMMENT_START`;
export const DELETE_COMMENT_SUCCESS = `${namespace}/DELETE_COMMENT_SUCCESS`;
export const DELETE_COMMENT_ERROR = `${namespace}/DELETE_COMMENT_ERROR`;

export const DELETE_REPORT_START = `${namespace}/DELETE_REPORT_START`;
export const DELETE_REPORT_SUCCESS = `${namespace}/DELETE_REPORT_SUCCESS`;
export const DELETE_REPORT_ERROR = `${namespace}/DELETE_REPORT_ERROR`;

export const POST_TAG_START = `${namespace}/POST_TAG_START`;
export const POST_TAG_SUCCESS = `${namespace}/POST_TAG_SUCCESS`;
export const POST_TAG_ERROR = `${namespace}/POST_TAG_ERROR`;

export const GET_TAGS_START = `${namespace}/GET_TAGS_START`;
export const GET_TAGS_SUCCESS = `${namespace}/GET_TAGS_SUCCESS`;
export const GET_TAGS_ERROR = `${namespace}/GET_TAGS_ERROR`;

export const GET_PID_ADDRESS_DATA_START = `${namespace}/GET_PID_ADDRESS_DATA_START`;
export const GET_PID_ADDRESS_DATA_SUCCESS = `${namespace}/GET_PID_ADDRESS_DATA_SUCCESS`;
export const GET_PID_ADDRESS_DATA_ERROR = `${namespace}/GET_PID_ADDRESS_DATA_ERROR`;

export const GET_TAXING_UNITS_START = `${namespace}/GET_TAXING_UNITS_START`;
export const GET_TAXING_UNITS_SUCCESS = `${namespace}/GET_TAXING_UNITS_SUCCESS`;
export const GET_TAXING_UNITS_ERROR = `${namespace}/GET_TAXING_UNITS_ERROR`;

export const DELETE_TAG_START = `${namespace}/DELETE_TAG_START`;
export const DELETE_TAG_SUCCESS = `${namespace}/DELETE_TAG_SUCCESS`;
export const DELETE_TAG_ERROR = `${namespace}/DELETE_TAG_ERROR`;

export const GET_PROPERTY_SEARCH_DATA_START = `${namespace}/GET_PROPERTY_SEARCH_DATA_START`;
export const GET_PROPERTY_SEARCH_DATA_SUCCESS = `${namespace}/GET_PROPERTY_SEARCH_DATA_SUCCESS`;
export const GET_PROPERTY_SEARCH_DATA_ERROR = `${namespace}/GET_PROPERTY_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_SEARCH_DATA_START`;
export const GET_APPRAISAL_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_SEARCH_DATA_ERROR`;

export const GET_POPUP_CONTENT_START = `${namespace}/GET_POPUP_CONTENT_START`;
export const GET_POPUP_CONTENT_SUCCESS = `${namespace}/GET_POPUP_CONTENT_SUCCESS`;
export const GET_POPUP_CONTENT_ERROR = `${namespace}/GET_POPUP_CONTENT_ERROR`;

export const GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START`;
export const GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START`;
export const GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_CI_POPUP_CONTENT_START = `${namespace}/GET_APPRAISAL_CI_POPUP_CONTENT_START`;
export const GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS = `${namespace}/GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS`;
export const GET_APPRAISAL_CI_POPUP_CONTENT_ERROR = `${namespace}/GET_APPRAISAL_CI_POPUP_CONTENT_ERROR`;

export const GET_CI_API_SETTINGS_START = `${namespace}/GET_CI_API_SETTINGS_START`;
export const GET_CI_API_SETTINGS_SUCCESS = `${namespace}/GET_CI_API_SETTINGS_SUCCESS`;
export const GET_CI_API_SETTINGS_ERROR = `${namespace}/GET_CI_API_SETTINGS_ERROR`;

export const GET_OWNER_TAGS_START = `${namespace}/GET_OWNER_TAGS_START`;
export const GET_OWNER_TAGS_SUCCESS = `${namespace}/GET_OWNER_TAGS_SUCCESS`;
export const GET_OWNER_TAGS_ERROR = `${namespace}/GET_OWNER_TAGS_ERROR`;

export const SET_CI_API_SETTINGS_START = `${namespace}/SET_CI_API_SETTINGS_START`;
export const SET_CI_API_SETTINGS_SUCCESS = `${namespace}/SET_CI_API_SETTINGS_SUCCESS`;
export const SET_CI_API_SETTINGS_ERROR = `${namespace}/SET_CI_API_SETTINGS_ERROR`;

export const GET_GIS_API_SETTINGS_START = `${namespace}/GET_GIS_API_SETTINGS_START`;
export const GET_GIS_API_SETTINGS_SUCCESS = `${namespace}/GET_GIS_API_SETTINGS_SUCCESS`;
export const GET_GIS_API_SETTINGS_ERROR = `${namespace}/GET_GIS_API_SETTINGS_ERROR`;

export const SET_GIS_API_SETTINGS_START = `${namespace}/SET_GIS_API_SETTINGS_START`;
export const SET_GIS_API_SETTINGS_SUCCESS = `${namespace}/SET_GIS_API_SETTINGS_SUCCESS`;
export const SET_GIS_API_SETTINGS_ERROR = `${namespace}/SET_GIS_API_SETTINGS_ERROR`;

export const GET_APPRAISAL_CI_INITIAL_DATA_START = `${namespace}/GET_APPRAISAL_CI_INITIAL_DATA_START`;
export const GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS`;
export const GET_APPRAISAL_CI_INITIAL_DATA_ERROR = `${namespace}/GET_APPRAISAL_CI_INITIAL_DATA_ERROR`;

export const GET_STATE_CODES_START = `${namespace}/GET_STATE_CODES_START`;
export const GET_STATE_CODES_SUCCESS = `${namespace}/GET_STATE_CODES_SUCCESS`;
export const GET_STATE_CODES_ERROR = `${namespace}/GET_STATE_CODES_ERROR`;

export const GET_MARKET_AREAS_START = `${namespace}/GET_MARKET_AREAS_START`;
export const GET_MARKET_AREAS_SUCCESS = `${namespace}/GET_MARKET_AREAS_SUCCESS`;
export const GET_MARKET_AREAS_ERROR = `${namespace}/GET_MARKET_AREAS_ERROR`;

export const FETCH_APPRAISAL_COMPANIES_START = `${namespace}/FETCH_APPRAISAL_COMPANIES_START`;
export const FETCH_APPRAISAL_COMPANIES_SUCCESS = `${namespace}/FETCH_APPRAISAL_COMPANIES_SUCCESS`;
export const FETCH_APPRAISAL_COMPANIES_ERROR = `${namespace}/FETCH_APPRAISAL_COMPANIES_ERROR`;

export const FETCH_REPORT_DEFINITIONS_START = `${namespace}/FETCH_REPORT_DEFINITIONS_START`;
export const FETCH_REPORT_DEFINITIONS_SUCCESS = `${namespace}/FETCH_REPORT_DEFINITIONS_SUCCESS`;
export const FETCH_REPORT_DEFINITIONS_ERROR = `${namespace}/FETCH_REPORT_DEFINITIONS_ERROR`;

export const SET_APPRAISALMAPDATA = `${namespace}/SET_APPRAISALMAPDATA`;

export const SET_MAPDATA = `${namespace}/SET_MAPDATA`;

export const SET_GISSETTINGS = `${namespace}/SET_GISSETTINGS`;

export const SET_GISSETTINGSSTATE = `${namespace}/SET_GISSETTINGSSTATE`;

export const SET_CISETTINGS = `${namespace}/SET_CISETTINGS`;

export const SET_MAPCOORDS = `${namespace}/SET_MAPCOORDS`;

export const SET_APPRAISALMAPCOORDS = `${namespace}/SET_APPRAISALMAPCOORDS`;

export const SET_REPORTMODIFIER = `${namespace}/SET_REPORTMODIFIER`;

export const RESET_ACTIVE_REPORT = `${namespace}/RESET_ACTIVE_REPORT`;

export const fetchTotalsInProgress = makeApiActionCreatorV3(
  api.fetchTotalsInProgress,
  FETCH_TOTALS_IN_PROGRESS_START,
  FETCH_TOTALS_IN_PROGRESS_SUCCESS,
  FETCH_TOTALS_IN_PROGRESS_ERROR,
);

export const deleteReport = makeApiActionCreatorV3(
  api.deleteReport,
  DELETE_REPORT_START,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_ERROR,
);

export const fetchSearchConfig = makeApiActionCreatorV3(
  api.fetchSearchConfig,
  FETCH_SEARCH_CONFIG_START,
  FETCH_SEARCH_CONFIG_SUCCESS,
  FETCH_SEARCH_CONFIG_ERROR,
);

export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG_START,
  FETCH_SEARCH_RESULTS_CONFIG_SUCCESS,
  FETCH_SEARCH_RESULTS_CONFIG_ERROR,
);

export const getReportJobs = makeApiActionCreatorV3(
  api.getReportJobs,
  GET_REPORT_JOBS_START,
  GET_REPORT_JOBS_SUCCESS,
  GET_REPORT_JOBS_ERROR,
);

export const processReportJob = makeApiActionCreatorV3(
  api.processReportJob,
  PROCESS_REPORT_JOB_START,
  PROCESS_REPORT_JOB_SUCCESS,
  PROCESS_REPORT_JOB_ERROR,
);

export const processAdjustedTotals = makeApiActionCreatorV3(
  api.processAdjustedTotals,
  PROCESS_REPORT_JOB_START,
  PROCESS_REPORT_JOB_SUCCESS,
  PROCESS_REPORT_JOB_ERROR,
);

export const createReportDefinition = makeApiActionCreatorV3(
  api.createReportDefinition,
  CREATE_REPORT_DEFINITION_START,
  CREATE_REPORT_DEFINITION_SUCCESS,
  CREATE_REPORT_DEFINITION_ERROR,
);

export const generateReportLong = makeApiActionCreatorV3(
  api.generateReportLong,
  GENERATE_REPORT_START,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_ERROR,
);

export const pollReportLong = makeApiActionCreatorV3(
  api.pollReportLong,
  GENERATE_REPORT_START,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_ERROR,
);

export const downloadReportLong = makeApiActionCreatorV3(
  api.downloadReportLong,
  DOWNLOAD_REPORT_LONG_START,
  DOWNLOAD_REPORT_LONG_SUCCESS,
  DOWNLOAD_REPORT_LONG_ERROR,
);

export const generateReport = makeApiActionCreatorV3(
  api.generateReport,
  GENERATE_REPORT_START,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_ERROR,
);

export const generateReportPaused = makeApiActionCreatorV3(
  api.generateReportPaused,
  GENERATE_REPORT_START,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_ERROR,
);

export const createReportEvents = makeApiActionCreatorV3(
  api.createReportEventsV2,
  CREATE_REPORT_EVENTS_START,
  CREATE_REPORT_EVENTS_SUCCESS,
  CREATE_REPORT_EVENTS_ERROR,
);

export const fetchMassCreate = makeApiActionCreatorV3(
  api.fetchMassCreate,
  FETCH_MASS_CREATE_START,
  FETCH_MASS_CREATE_SUCCESS,
  FETCH_MASS_CREATE_ERROR,
);

export const updateReportDefinition = makeApiActionCreatorV3(
  api.updateReportDefinition,
  UPDATE_REPORT_DEFINITION_START,
  UPDATE_REPORT_DEFINITION_SUCCESS,
  UPDATE_REPORT_DEFINITION_ERROR,
);

export const createReportSubmission = makeApiActionCreatorV3(
  api.createReportSubmission,
  CREATE_REPORT_SUBMISSION_START,
  CREATE_REPORT_SUBMISSION_SUCCESS,
  CREATE_REPORT_SUBMISSION_ERROR,
);

export const finalizeReportSubmission = makeApiActionCreatorV3(
  api.finalizeReportSubmission,
  FINALIZE_REPORT_SUBMISSION_START,
  FINALIZE_REPORT_SUBMISSION_SUCCESS,
  FINALIZE_REPORT_SUBMISSION_ERROR,
);

export const fetchReportSubmissions = makeApiActionCreatorV3(
  api.fetchReportSubmissions,
  FETCH_REPORT_SUBMISSIONS_START,
  FETCH_REPORT_SUBMISSIONS_SUCCESS,
  FETCH_REPORT_SUBMISSIONS_ERROR,
);

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const searchStandalone = makeApiActionCreatorV3(
  api.search,
  SEARCH_STANDALONE_START,
  SEARCH_STANDALONE_SUCCESS,
  SEARCH_STANDALONE_ERROR,
);

export const fetchReport = makeApiActionCreatorV3(
  api.fetchReport,
  FETCH_REPORT_START,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
);

export const fetchReportStandalone = makeApiActionCreatorV3(
  api.fetchReport,
  FETCH_REPORT_STANDALONE_START,
  FETCH_REPORT_STANDALONE_SUCCESS,
  FETCH_REPORT_STANDALONE_ERROR,
);

export const postComment = makeApiActionCreatorV3(
  api.postComment,
  POST_COMMENT_START,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_ERROR,
);

export const getReportInfo = makeApiActionCreatorV3(
  api.getReportInfo,
  GET_REPORT_INFO_START,
  GET_REPORT_INFO_SUCCESS,
  GET_REPORT_INFO_ERROR,
);

export const getComments = makeApiActionCreatorV3(
  api.getComments,
  GET_COMMENTS_START,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_ERROR,
);

export const deleteComment = makeApiActionCreatorV3(
  api.deleteComment,
  DELETE_COMMENT_START,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_ERROR,
);

export const getTaxingUnits = makeApiActionCreatorV3(
  api.getTaxingUnits,
  GET_TAXING_UNITS_START,
  GET_TAXING_UNITS_SUCCESS,
  GET_TAXING_UNITS_ERROR,
);

export const getPidAddressData = makeApiActionCreatorV3(
  api.getPropertyData,
  GET_PID_ADDRESS_DATA_START,
  GET_PID_ADDRESS_DATA_SUCCESS,
  GET_PID_ADDRESS_DATA_ERROR,
);

export const getCiApiSettings = makeApiActionCreatorV3(
  api.getCiApiSettings,
  GET_CI_API_SETTINGS_START,
  GET_CI_API_SETTINGS_SUCCESS,
  GET_CI_API_SETTINGS_ERROR,
);

export const setCiApiSettings = makeApiActionCreatorV3(
  api.setCiApiSettings,
  SET_CI_API_SETTINGS_START,
  SET_CI_API_SETTINGS_SUCCESS,
  SET_CI_API_SETTINGS_ERROR,
);

export const getGisApiSettings = makeApiActionCreatorV3(
  api.getGisApiSettings,
  GET_GIS_API_SETTINGS_START,
  GET_GIS_API_SETTINGS_SUCCESS,
  GET_GIS_API_SETTINGS_ERROR,
);

export const setGisApiSettings = makeApiActionCreatorV3(
  api.setGisApiSettings,
  SET_GIS_API_SETTINGS_START,
  SET_GIS_API_SETTINGS_SUCCESS,
  SET_GIS_API_SETTINGS_ERROR,
);

export const getPropertySearchData = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_PROPERTY_SEARCH_DATA_START,
  GET_PROPERTY_SEARCH_DATA_SUCCESS,
  GET_PROPERTY_SEARCH_DATA_ERROR,
);

export const getAppraisalSearchData = makeApiActionCreatorV3(
  api.getAppraisalSearchData,
  GET_APPRAISAL_SEARCH_DATA_START,
  GET_APPRAISAL_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_SEARCH_DATA_ERROR,
);

export const getPopupContent = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_POPUP_CONTENT_START,
  GET_POPUP_CONTENT_SUCCESS,
  GET_POPUP_CONTENT_ERROR,
);

export const getAppraisalCiPropertySearchData = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START,
  GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR,
);

export const fetchRollCorrections = makeApiActionCreatorV3(
  api.fetchRollCorrections,
  FETCH_ROLL_CORRECTIONS_START,
  FETCH_ROLL_CORRECTIONS_SUCCESS,
  FETCH_ROLL_CORRECTIONS_ERROR,
);

export const getAppraisalCiAppraisalSearchData = makeApiActionCreatorV3(
  api.getAppraisalSearchData,
  GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START,
  GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR,
);

export const getAppraisalCiPopupContent = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_APPRAISAL_CI_POPUP_CONTENT_START,
  GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS,
  GET_APPRAISAL_CI_POPUP_CONTENT_ERROR,
);

export const getAppraisalCiInitialData = makeApiActionCreatorV3(
  api.getAppraisalCiInitialData,
  GET_APPRAISAL_CI_INITIAL_DATA_START,
  GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS,
  GET_APPRAISAL_CI_INITIAL_DATA_ERROR,
);

export const getOwnerTags = makeApiActionCreatorV3(
  api.getOwnerTags,
  GET_OWNER_TAGS_START,
  GET_OWNER_TAGS_SUCCESS,
  GET_OWNER_TAGS_ERROR,
);

export const getStateCodes = makeApiActionCreatorV3(
  api.getStateCodes,
  GET_STATE_CODES_START,
  GET_STATE_CODES_SUCCESS,
  GET_STATE_CODES_ERROR,
);

export const getMarketAreas = makeApiActionCreatorV3(
  api.getMarketAreas,
  GET_MARKET_AREAS_START,
  GET_MARKET_AREAS_SUCCESS,
  GET_MARKET_AREAS_ERROR,
);

export const fetchAppraisalCompanies = makeApiActionCreatorV3(
  api.fetchAppraisalCompanies,
  FETCH_APPRAISAL_COMPANIES_START,
  FETCH_APPRAISAL_COMPANIES_SUCCESS,
  FETCH_APPRAISAL_COMPANIES_ERROR,
);

export const fetchReportDefinitions = makeApiActionCreatorV3(
  api.fetchReportDefinitions,
  FETCH_REPORT_DEFINITIONS_START,
  FETCH_REPORT_DEFINITIONS_SUCCESS,
  FETCH_REPORT_DEFINITIONS_ERROR,
);

export function setAppraisalMapData(data) {
  return async dispatch => {
    dispatch({ type: SET_APPRAISALMAPDATA, windowData: data });
  };
}

export function setMapData(data) {
  return async dispatch => {
    dispatch({ type: SET_MAPDATA, windowData: data });
  };
}

export function setGisSettings(data) {
  return async dispatch => {
    dispatch({ type: SET_GISSETTINGS, windowData: data });
  };
}

export function setGisSettingsState(data) {
  return async dispatch => {
    dispatch({ type: SET_GISSETTINGSSTATE, windowData: data });
  };
}

export function setCiSettings(data) {
  return async dispatch => {
    dispatch({ type: SET_CISETTINGS, windowData: data });
  };
}

export function setMapCoords(data) {
  return async dispatch => {
    dispatch({ type: SET_MAPCOORDS, windowData: data });
  };
}

export function setAppraisalMapCoords(data) {
  return async dispatch => {
    dispatch({ type: SET_APPRAISALMAPCOORDS, windowData: data });
  };
}

export function resetActiveReport() {
  return async dispatch => {
    dispatch({ type: RESET_ACTIVE_REPORT });
  };
}

export function setReportModifier(modifier) {
  return async dispatch => {
    dispatch({ type: SET_REPORTMODIFIER, windowData: modifier });
  };
}
